import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false,
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__online-credit-solution',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__online-credit-solution .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__online-credit-solutions',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__online-credit-solutions .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__solutions-complex',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__solutions-complex .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__online-credit-solution-keys',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__online-credit-solution-keys .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__connect',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__connect .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

});



// WEBPACK FOOTER //
// ./app/scripts/pages/solutions/online-credit.js